import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./twb.css";

const BuzzLife = (props) => {
  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <button className='close' onClick={toggle}>
      &times;
    </button>
  );

  return (
    <div>
      <button className='button' onClick={toggle}>
        See the project
      </button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modal title
        </ModalHeader>
        <ModalBody className='modalBody'>
          <img
            src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614130928/FireShot_Capture_220_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_vh5vbs.png'
            alt='img'
          />
          <h2>BuzzLife</h2>
          <div className='tag-body-single'>
            <div className='tags'>Ruby on Rails</div>
            <div className='tags'>Javascript</div>
            <div className='tags'>PostgreSQl</div>
          </div>
          <p>
            This is part of Capstone project in Microverse's rails curriculum,
            to build a Ruby on Rails application where people can write
            articles. This is a website with articles about books, wedding
            business, fishing equipment, mushrooms - anything that you can write
            an article.
          </p>
          <div className='tag-body-live'>
            <div className='tag one'>
              <a
                href='https://buzzlife.herokuapp.com/'
                target='_blank'
              >
                See live
              </a>
            </div>
            <div className='tag two'>
              <a
                href='https://github.com/Elijahscriptdev/online-store'
                target='_blank'
              >
                see code
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default BuzzLife;
